import { gql } from 'graphql-request';
import withFragments from 'utils/graphql';

import ActivityCard from 'fragments/ActivityCard';

const getActivities = withFragments(
  gql`
    mutation getActivities($activityIndexId: Int, $filters: [FilterType], $themeId: Int) {
      getActivities(filters: $filters, activityIndexId: $activityIndexId, themeId: $themeId) {
        activities {
          ...ActivityCard
          ...CustomActivityCard
        }
        resultCount
        activeFiltersGeneric {
          name
          slug
          filterSet {
            name
            slug
          }
        }
        activeFiltersTheme {
          name
          slug
          filterSet {
            name
            slug
            theme {
              icon
              name
            }
          }
        }
        themeFilters {
          name
          slug
          theme {
            icon
            name
          }
          filters {
            name
            slug
          }
        }
      }
    }
  `,
  { ActivityCard },
);

export default getActivities;
